import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

import { Quantity } from './quantity.types';

type QuantityTextViewProps = {
   readonly quantity: Quantity;
};

export const QuantityTextView = (props: QuantityTextViewProps): JSX.Element => {
   return (
      <StyledPrescriptionTextView testId={'quantity'} compact label={prescriptionTranslationKeys.quantity.quantity}>
         {props.quantity}
      </StyledPrescriptionTextView>
   );
};
